import SectionHeading from "@/components/base/SectionHeading";
import { episodes } from "@/mocks/home";

export default function EpisodesSection() {
  return (
    <section id="episodes" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="热门分集"
            title="黑料短剧分集介绍精选"
            desc="从开场悬念到线索收束，挑出讨论度最高的几集，逐集说明关键道具与剧情走向。"
          />
          <a
            href="#faq"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-bold text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
          >
            更新与观影问题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {episodes.map((ep) => (
            <article
              key={ep.no}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={ep.image}
                  alt={`黑料短剧${ep.no}《${ep.title}》剧照`}
                  title={`黑料短剧 ${ep.no} 剧情介绍`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/75 px-2.5 py-1 font-label text-xs font-bold text-background-50">
                  {ep.no}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">《{ep.title}》</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{ep.summary}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {ep.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}